import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51f6b1c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "key" }
const _hoisted_2 = ["value", "onInput"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "root",
      style: _normalizeStyle(`height:${_ctx.size.height}px`)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (element) => {
        return (_openBlock(), _createElementBlock("div", {
          key: element.key,
          class: "element"
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(element.displayName), 1),
          _createElementVNode("input", {
            class: "value-input",
            value: element.value,
            onInput: ($event: any) => (_ctx.change($event, element.key))
          }, null, 40, _hoisted_2)
        ]))
      }), 128))
    ], 4)
  ]))
}